import { IonAlert } from '@ionic/react';
import { useTranslation } from 'react-i18next';

import styles from './merge-alert.module.css';

/* eslint-disable-next-line */
export interface MergeAlertProps {
  isOpen: boolean;
  header?: string;
  message?: string;
  onCancel: () => void;
  onConfirm?: () => void;
}

export function MergeAlert(props: MergeAlertProps) {
  const { t } = useTranslation(['common'], { useSuspense: false });
  
  return (
    <IonAlert
      backdropDismiss={false}
      buttons={[
        {
          text: t('common:cancel'),
          role: 'cancel',
          handler: props.onCancel,
        },
        {
          text: t('common:confirm'),
          role: 'confirm',
          cssClass: styles['delete-dialog__confirm-button'],
          handler: props.onConfirm,
        },
      ]}
      header={props.header || (t('common:merge_alert_title') as string)}
      isOpen={props.isOpen}
      message={props.message || (t('common:merge_alert_message') as string)}
    ></IonAlert>
  );
}

export default MergeAlert;
